(() => {
  const init = () => {
    const root = document.querySelector('[data-dermana-product]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const copy = root.dataset;
    const bar = root.querySelector('[data-dmr-bar]');
    const heroCta = root.querySelector('[data-hero-cta]');
    const radios = [...root.querySelectorAll('[data-variant-radio]')];
    const stock = root.querySelector('[data-stock-status]');
    const pad = n => String(n).padStart(2, '0');
    const formatClock = n => `${pad(Math.floor(n / 3600))}:${pad(Math.floor(n % 3600 / 60))}:${pad(n % 60)}`;

    // Kargo: depo haftanın 7 günü kargo çıkarıyor (16 Eki). Kesim saatleri Türkiye saatiyle data-cutoffs (ör. "13" veya "13,18").
    // Bir sonraki gerçek kesime 12 saatten az varsa canlı geri sayım; daha uzunsa "Yarın kargoda" sabit satırı.
    const strip = root.querySelector('[data-ship-strip]');
    const cutoffs = String(strip?.dataset.cutoffs || strip?.dataset.cutoff || '13').split(',').map(Number).filter(h => h >= 0 && h < 24).sort((a, b) => a - b);
    const shipText = root.querySelector('[data-ship-text]');
    const shipClock = root.querySelector('[data-ship-clock]');
    const MAX = 12 * 3600;
    const tickShipping = () => {
      const now = Date.now();
      const tr = new Date(now + 10800000);
      let target = 0, offset = 0;
      for (; offset < 2 && !target; offset++) {
        for (const h of cutoffs) {
          const t = Date.UTC(tr.getUTCFullYear(), tr.getUTCMonth(), tr.getUTCDate() + offset, h - 3);
          if (t > now) { target = t; break; }
        }
      }
      offset -= 1;
      const seconds = target ? Math.floor((target - now) / 1000) : Infinity;
      if (seconds <= MAX) {
        if (shipText) shipText.textContent = `${offset === 0 ? 'Bugün' : 'Yarın'} kargoda · sipariş için kalan`;
        if (shipClock) { shipClock.hidden = false; shipClock.textContent = formatClock(seconds); }
      } else {
        if (shipText) shipText.textContent = 'Siparişiniz yarın kargoda · haftanın 7 günü gönderim';
        if (shipClock) shipClock.hidden = true;
      }
      strip?.classList.add('is-live');
    };
    tickShipping();
    const shippingInterval = setInterval(tickShipping, 1000);

    const updateStock = () => {
      const selected = radios.find(r => r.checked);
      if (!selected || !stock) return;
      const qty = Number(selected.dataset.inventory);
      if (selected.dataset.tracked !== 'true' || !Number.isFinite(qty) || qty <= 0) { stock.hidden = true; return; }
      stock.querySelector('[data-stock-count]').textContent = `${qty} ${copy.stockUnit}`;
      const meter = stock.querySelector('[data-stock-meter]');
      meter.max = Math.max(qty, 50); meter.value = qty;
      stock.hidden = false;
    };
    radios.forEach(r => r.addEventListener('change', updateStock));
    updateStock();

    // Ölçüm: kapıda öde formu açılışını Shopify müşteri olaylarına yayınla (Özel piksel buradan dinleyebilir).
    const publish = (name, extra = {}) => {
      const selected = radios.find(r => r.checked);
      const detail = {
        value: Number(selected?.dataset.value || 0),
        currency: 'TRY',
        variant_id: selected?.value || '',
        content_ids: selected ? [selected.value] : [],
        num_items: 1,
        ...extra
      };
      try { window.Shopify?.analytics?.publish?.(name, detail); } catch (_) {}
    };

    const openCod = (source) => {
      const button = document.getElementById('rsi_buy_now_button');
      publish('dermana_cod_open', { source: source || 'button' });
      if (button && button.getAttribute('aria-disabled') !== 'true' && !button.disabled) { button.click(); return; }
      const target = root.querySelector('#paketler') || root.querySelector('.dpd-actions');
      target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (!root.querySelector('.dmr-cod-notice')) {
        const notice = document.createElement('p'); notice.className = 'dmr-cod-notice'; notice.setAttribute('role', 'status'); notice.textContent = copy.codError;
        root.querySelector('.dpd-actions')?.after(notice);
      }
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cod-open]');
      if (!trigger) return;
      event.preventDefault();
      openCod(trigger.classList.contains('dmr-bar__btn') ? 'sticky' : trigger.hasAttribute('data-hero-cta') ? 'hero' : 'section');
    });
    // Releasit'in kendi butonu doğrudan tıklanırsa da olay yayınla.
    document.addEventListener('click', event => {
      if (event.isTrusted && event.target.closest('#rsi_buy_now_button')) publish('dermana_cod_open', { source: 'form' });
    }, true);

    let frame;
    const formOpen = () => Boolean(document.querySelector('#rsi_form_wrapper[open]') || document.querySelector('[data-dmr-exit][open]'));
    const updateUi = () => {
      frame = undefined;
      const submit = document.querySelector('#rsi_form_wrapper .rsi-submit_button');
      if (submit && !submit.parentElement.querySelector('.dmr-form-trust')) {
        const trust = document.createElement('p'); trust.className = 'dmr-form-trust';
        trust.textContent = root.dataset.formTrust || '';
        if (trust.textContent) submit.after(trust);
      }
      if (!bar || !heroCta) return;
      const rect = heroCta.getBoundingClientRect();
      const visible = rect.bottom < 0 && !formOpen();
      if (bar.classList.contains('is-visible') !== visible) {
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        bar.querySelector('button')?.setAttribute('tabindex', visible ? '0' : '-1');
        document.body.classList.toggle('dmr-bar-on', visible);
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(updateUi); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'style'] });
    updateUi();

    const exitKey = 'dermana_exit_shown_v2';
    let shown = false;
    try { shown = sessionStorage.getItem(exitKey) === '1'; } catch (_) {}
    const dialog = document.createElement('dialog'); dialog.className = 'dmr-exit'; dialog.dataset.dmrExit = ''; dialog.setAttribute('aria-labelledby', 'dermana-exit-title');
    const box = document.createElement('div'); box.className = 'dmr-exit__box';
    const closeButton = document.createElement('button'); closeButton.type = 'button'; closeButton.className = 'dmr-exit__x'; closeButton.setAttribute('aria-label', copy.close); closeButton.textContent = '×';
    const kicker = document.createElement('span'); kicker.className = 'dmr-exit__kicker'; kicker.textContent = copy.exitKicker;
    const title = document.createElement('h3'); title.id = 'dermana-exit-title'; title.textContent = copy.exitTitle;
    const body = document.createElement('p'); body.textContent = copy.exitBody;
    const cta = document.createElement('button'); cta.type = 'button'; cta.className = 'dmr-exit__cta'; cta.textContent = copy.exitCta;
    const no = document.createElement('button'); no.type = 'button'; no.className = 'dmr-exit__no'; no.textContent = copy.exitNo;
    box.append(closeButton, kicker, title, body, cta, no); dialog.append(box); document.body.append(dialog);
    const close = () => { dialog.close(); updateUi(); };
    closeButton.addEventListener('click', close); no.addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', updateUi);
    cta.addEventListener('click', () => { close(); openCod('exit'); });
    document.addEventListener('mouseout', event => {
      if (shown || event.clientY > 0 || event.relatedTarget || !matchMedia('(hover: hover)').matches || document.querySelector('#rsi_form_wrapper[open]')) return;
      shown = true;
      try { sessionStorage.setItem(exitKey, '1'); } catch (_) {}
      dialog.showModal(); updateUi();
    });
    window.addEventListener('pagehide', () => { clearInterval(shippingInterval); observer.disconnect(); }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
